import { motion, useReducedMotion } from "framer-motion";
import { Reveal, EASE } from "./Reveal";

const PhoneMockup = () => (
  <div className="relative mx-auto w-[270px] sm:w-[300px]">
    <div
      className="absolute -inset-14 rounded-full bg-growth/25 blur-3xl"
      aria-hidden="true"
    />
    <motion.div
      whileHover={{ rotate: -1.5, y: -6 }}
      transition={{ duration: 0.4, ease: EASE }}
      data-testid="coacher-phone-mockup"
      className="relative overflow-hidden rounded-[40px] border-[10px] border-ink bg-white shadow-[0_30px_80px_rgba(18,60,45,0.35)]"
    >
      <img
        src="/assets/coacher-lineup.jpeg"
        alt="CoachER game lineup screen showing nine field positions and the bench"
        className="block w-full"
        loading="lazy"
      />
    </motion.div>
  </div>
);

export const CoachERFeature = () => {
  const reduce = useReducedMotion();
  return (
    <section
      data-testid="coacher-section"
      className="relative overflow-hidden bg-sage/50"
    >
      <div className="mx-auto grid max-w-[1240px] items-center gap-16 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-32">
        <Reveal>
          <div data-testid="coacher-product-card">
            <p className="font-display text-xs font-semibold uppercase tracking-[0.22em] text-growth sm:text-sm">
              What we're building
            </p>
            <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
              CoachER
            </h2>
            <p className="mt-2 font-display text-xl font-medium text-evergreen">
              Your Digital Dugout Assistant
            </p>
            <p className="mt-6 max-w-[560px] font-body text-lg leading-relaxed text-slate">
              CoachER helps youth sports coaches organize their teams, build better practices,
              manage lineups, capture player notes, and spend less time piecing everything
              together across different tools.
            </p>
            <p className="mt-4 max-w-[560px] font-body text-base leading-relaxed text-slate">
              Built from firsthand experience in the dugout, CoachER is the first product owned
              and developed by Build Make Win Ventures LLC.
            </p>
            <div className="mt-8">
              <motion.a
                href="https://trycoacher.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-coacher-button"
                whileHover={reduce ? undefined : { scale: 1.02 }}
                whileTap={reduce ? undefined : { scale: 0.98 }}
                className="group inline-flex items-center gap-2 rounded-xl bg-growth px-7 py-3.5 font-display text-base font-semibold text-white transition-colors duration-200 hover:bg-evergreen"
              >
                Visit CoachER
                <svg viewBox="0 0 24 24" className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </motion.a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.15} y={36}>
          <PhoneMockup />
        </Reveal>
      </div>
    </section>
  );
};
